import { createEvent } from "effector";

const started = createEvent();

export const app = {
  started,
};
